/** @module csi/widget/SortIndicator */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dojo/text!./SortIndicator.html"
], function(declare,_TemplatedMixin,_WidgetBase,template) {

	return declare([_WidgetBase, _TemplatedMixin], {
		baseClass: "csi-sort-indicator",
		templateString: template,

		/** @property {string} level - should only be 2 or above; do not show if first level of sort */
		level: "",

		/** @property {boolean} descending */
		descending: false,

		/**
		 * Map level property to DOM
		 * @param {boolean} value
		 */
		_setLevelAttr: function(value) {
			$(this.domNode).toggleClass(this.baseClass + "-with-level", !!value);
			$(this.levelNode).text(value);
			this._set("level", value);
		},

		/**
		 * Adjust styling if descending
		 * @param {boolean} value
		 */
		_setDescendingAttr: function(value) {
			const css = this.baseClass + "-active";
			$(this.upNode).toggleClass(css, !value);
			$(this.downNode).toggleClass(css, value);
			this._set("descending", value);
		}
	});
});
